const kVer = (section: string) => `cms:v:${section}`;
const kData = (section: string) => `cms:d:${section}`;
const kTime = (section: string) => `cms:t:${section}`;

export function loadCache<T>(section: string): { version: number | null; data: T | null; fetchedAt: number | null } {
  try {
    const vRaw = localStorage.getItem(kVer(section));
    const dRaw = localStorage.getItem(kData(section));
    const tRaw = localStorage.getItem(kTime(section));
    return {
      version: vRaw ? Number(vRaw) : null,
      data: dRaw ? (JSON.parse(dRaw) as T) : null,
      fetchedAt: tRaw ? Number(tRaw) : null,
    };
  } catch { return { version: null, data: null, fetchedAt: null }; }
}

export function saveCache<T>(section: string, version: number, data: T) {
  try {
    localStorage.setItem(kVer(section), String(version));
    localStorage.setItem(kData(section), JSON.stringify(data));
    localStorage.setItem(kTime(section), String(Date.now()));
  } catch { /* ignore */ }
}

export function clearCache(section: string) {
  localStorage.removeItem(kVer(section));
  localStorage.removeItem(kData(section));
  localStorage.removeItem(kTime(section));
}

export function isStaleByTTL(fetchedAt: number | null, ttlHours: number): boolean {
  if (!fetchedAt) return true;
  const ms = ttlHours * 3600 * 1000;
  return Date.now() - fetchedAt > ms;
}
